<template>
  <div>
    <div class="panel-block is-flex is-justify-content-space-between custom-panel orm-panel-border pb-3"
      :class="[{'custom-panel-with-no-chart': isUninvoicedJobsAndChartDisabled}]">
      <p class="is-flex is-align-items-center">ORM</p>
    </div>
    <div class="panel-block custom-panel">
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.UnRead)">
        <span class="is-size-7">Inbox</span>
        <DashboardWebServiceCircularStatus :value="orm?.unRead"
          :color-code="getButtonColorCode(orm?.unRead, isGreen)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.ToSend)">
        <span class="is-size-7">Failed</span>
        <DashboardWebServiceCircularStatus :value="orm?.sendFailed"
          :color-code="getButtonColorCode(orm?.sendFailed, isRed)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.ToSend)">
        <span class="is-size-7">Outbox</span>
        <DashboardWebServiceCircularStatus :value="orm?.toSend"
          :color-code="getButtonColorCode(orm?.toSend, isGray)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.SyncFailed)">
        <span class="is-size-7">Sync Fail</span>
        <DashboardWebServiceCircularStatus :value="orm?.syncFailed"
          :color-code="getButtonColorCode(orm?.syncFailed, isRed)"
          :width="'40px'"
          :height="'40px'" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardWebServiceCircularStatus from '@/views/dashboard/DashboardWebServiceCircularStatus.vue'
import messageStatusTypes from '@/enums/MessageStatusTypes'
import { Columns } from '@/views/pnetmessage/columns'

export default {
  name: 'DashboardOrm',
  components: { DashboardWebServiceCircularStatus },

  props: {
    orm: null,
    isUninvoicedJobsAndChartDisabled: Boolean
  },
  data() {
    return {
      isGreen: '#54B700',
      isRed: '#D92550',
      isGray: '#495057',
      filter: {
        quoteNo: '',
        rego: '',
        claimNo: '',
        messageTypeId: 0,
        messageStatusId: this.tab,
        sortColumn: Columns[Columns.length - 2].name,
        sortOrder: Columns[Columns.length - 2].defaultOrder,
        pageIndex: 1,
        pageSize: 18
      }
    }
  },
  computed: {
    messageStatusTypes() {
      return messageStatusTypes
    },
    filterKey() {
      if (!this.$userInfo) return ''
      return `${this.$userInfo.sessionId}|ormmessage|filter`
    }
  },
  methods: {
    getButtonColorCode(value, color) {
      if (value > 0) return color
      return this.isGray
    },
    onClick(tab) {
      console.log('tab', tab)
      const obj = {
        ...this.filter,
        messageStatusId: tab
      }
      sessionStorage.setItem(this.filterKey, JSON.stringify(obj))
      this.$router.push('ormMessages')
    }
  }
}
</script>

<style scoped>
.custom-panel {
  color: #fff;
}

.orm-panel-border:not(:last-child) {
  border-bottom: 1px solid #bda448;
}

.message-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.clickable-message {
  cursor: pointer;
  border: 1px transparent solid;
  opacity: 1;
}

.clickable-message:hover {
  background: linear-gradient(to right, #222 50%, hsl(0, 0%, 8%) 50%);
  background-size: 200% 120%;
  background-position: right;
}
</style>